const APIs = {
  REPORTS: 'admin/reports',
  SINGLE_REPORTS: 'admin/reports/:id',
}

export default APIs
